// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20XFI","colMin":"styles_colMin__9n0Jo"};